import { GridFilterTypes } from "../../../grid/AgGridManager";
import { FieldSchema } from "../../../Schema";

/**
 * The V&V lifecycle states an ASPIRE-sourced device can be in.
 *
 * Declared here rather than as `data.options` because the field is not editable through the
 * form — the value arrives from the V&V Linked Instance — and an enum on the `data` aspect
 * would put it through `DataManager` coercion and render it as a select. The grid is the only
 * aspect that needs the option list, so the list stays grid-scoped.
 */
export const vnvStatusFilterValues = [
  "Not assigned",
  "Active", 
  "In Maintenance", 
  "Temporary Deviation", 
  "Permanent Deviation"
];

/**
 * V&V status of a device held in the V&V Linked Instance.
 *
 * Grid-only: the column is offered in the columns tool panel but stays out of the default
 * view, so standard laboratory operations see the same table as before. Standard, non-V&V
 * equipment carries no value here — the app renders the empty cell as "Not Applicable".
 */
export const vnvStatus: FieldSchema = {
  name: "vnvStatus",
  grid: {
    displayed: true,
    defaultVisible: false,
    order: 84,
    label: "V&V Status",
    filter: GridFilterTypes.SET,
    filterValues: vnvStatusFilterValues,
    sortable: true,
  },
};
